import { useEffect, useState } from 'react';
import { globalBus } from '../../streams/wsBus';
import { useActionFeedback } from '../../streams/useActionFeedback';

type ApprovalRow = [string, string, string, string, string];

export function ApprovalsTray() {
  const [items, setItems] = useState<ApprovalRow[]>([]);
  const { states, fire } = useActionFeedback(globalBus);

  useEffect(() => {
    const unsub = globalBus.subscribe((message) => {
      if (message.t === 'scene' && message.id === 'hivecore.approvals') {
        setItems(message.body?.widgets?.find((w: any) => w.key === 'approvals.queue')?.rows ?? []);
      }
    });
    globalBus.sendIntent('scene.request', { id: 'hivecore.approvals' });
    return unsub;
  }, []);

  const approve = (id: string) => fire(`approvals.approve.${id}`, 'approvals.approve', { id });
  const deny = (id: string) => fire(`approvals.deny.${id}`, 'approvals.deny', { id });

  return (
    <div className="panel">
      <header className="panel-header">
        <h2>Pending Approvals</h2>
      </header>
      <table className="table">
        <thead>
          <tr>
            <th>Title</th>
            <th>Requestor</th>
            <th>Type</th>
            <th>Submitted</th>
            <th>Decision</th>
          </tr>
        </thead>
        <tbody>
          {items.length === 0 ? (
            <tr>
              <td colSpan={5} style={{ textAlign: 'center', padding: '24px', color: 'var(--muted)' }}>
                No approvals waiting.
              </td>
            </tr>
          ) : (
            items.map(([id, title, requestor, type, submitted]) => (
              <tr key={id}>
                <td>{title}</td>
                <td>{requestor}</td>
                <td>{type}</td>
                <td>{new Date(submitted).toLocaleTimeString()}</td>
                <td style={{ display: 'flex', gap: '8px' }}>
                  <button data-state={states[`approvals.approve.${id}`] ?? 'idle'} onClick={() => approve(id)}>Approve</button>
                  <button data-state={states[`approvals.deny.${id}`] ?? 'idle'} onClick={() => deny(id)}>Deny</button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
